import React from 'react'
import MenuCategory from './MenuCategory'
import ActionButton from '../../Share/ActionButton'
import { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import './MenuList.scss'
import { usePickupContext } from '../../../context/Pickup/pickup'

export default function MenuList(props) {
	const history = useHistory()
	const [disabled, setDisabled] = useState(true)
	const { orderSheet } = usePickupContext()
	const params = useParams()
	function onClick() {
		history.push(`/pickup/${params.mallUri}/order-sheet`)
	}

	useEffect(() => {
		if (orderSheet && orderSheet.length > 0)
			setDisabled(false)
		else
			setDisabled(true)


	}, [orderSheet])


	return (
		<div className="menu-list-container">
			{props.categories.map((category, idx) => <MenuCategory category={category} key={idx}/>)}
			<div className="button-container">
				<ActionButton
					onClick={onClick}
					disabled={disabled}
					variant="contained"
					color="primary"
					fullWidth={true}
					className="action-button"
					label="장바구니">
				</ActionButton>
			</div>
		</div>
	)
}
